import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {FormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import moment from 'moment/moment';
import {TipoPagamentoEcgTerceiroService} from '../../contratacao/operacao/tipo-pagamento-ecg-terceiro.service';
import {TipoPagamentoEcgTerceiro} from '../../../model/tipo-pagamento-ecg-terceiro';
import { BaseEntityComponent, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import {OcorrenciaValidacaoVO} from '../../../shared/ocorrencia-validacao.vo';
import {LimitePagamentoEcgTerceiroService} from '../../limite-pagamento-ecg-por-terceiros/limite-pagamento-ecg-terceiro.service';
import {LimitePagamentoEcgTerceiro} from '../../../model/limite-pagamento-ecg-terceiro';

@Component({
  selector: 'app-ecg-por-terceiros-cadastro',
  templateUrl: './ecg-por-terceiros-cadastro.component.html',
  styleUrls: ['./ecg-por-terceiros-cadastro.component.scss'],
  standalone: false
})
export class EcgPorTerceirosCadastroComponent extends BaseEntityComponent<TipoPagamentoEcgTerceiro> implements OnInit, OnDestroy {

  private readonly destroy$: Subject<any> = new Subject();

  modoCadastro: boolean = false;
  modoVisualizacao: boolean = false;
  modoEdicaoR: boolean = false;
  ideEcgTerceiro: number;
  limitesCedidosEcg: LimitePagamentoEcgTerceiro[];
  protected cadastroTerceiroForm: UntypedFormGroup;
  private ocorrencias: OcorrenciaValidacaoVO[] = [];
  protected dataAmanha: Date = new Date();

  constructor(protected injector: Injector,
              public formBuilder: FormBuilder,
              private TipoPagamentoEcgTerceiroService: TipoPagamentoEcgTerceiroService,
              private limitePagamentoEcgTerceiroService: LimitePagamentoEcgTerceiroService,
              private loadingService: BnLoadingService) {

    super(TipoPagamentoEcgTerceiroService);
    this.dataAmanha = moment(this.dataAmanha).add(1, 'days').toDate();

  }

  ngOnInit(): void {
    this.createReactiveForm();
    this.modoStatus();
    this.atualizaStatusCamposEdicao();
    this.buscarDados();
  }

  buscarDados() {
    if (this.modoEdicaoR || this.modoVisualizacao) {
      this.TipoPagamentoEcgTerceiroService.buscarDadosEdicaoVisualizacao(this.ideEcgTerceiro).subscribe(res => {
        this.cadastroTerceiroForm.patchValue({
          pagamentoEcgPor: res.nomeTipoPagamentoEcgTerceiro,
          valorLimiteTotal: res.valorLimiteTotalEcgPagoPorTerceiro,
          dataReferencia: new Date(res.dataReferencia),
        });
      });
      this.limitePagamentoEcgTerceiroService.buscarLimitesPagamentoEcgTerceirosPorTipo(this.ideEcgTerceiro).subscribe(res => {
        this.limitesCedidosEcg = res;
      })
    }
  }

  createReactiveForm() {
    this.cadastroTerceiroForm = this.formBuilder.group({
      pagamentoEcgPor: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿ\s]*$/)]],
      valorLimiteTotal: ['', Validators.required],
      dataReferencia: ['', Validators.required],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  async salvar() {
    if (this.cadastroTerceiroForm.invalid) {
      this.cadastroTerceiroForm.markAllAsTouched();
      return;
    }
    this.loadingService.bloqueiaTela();
    this.antesDeSalvar();
    this.ocorrencias = [];
    const cadastro = {
      nomeTipoPagamentoEcgTerceiro: this.cadastroTerceiroForm.get('pagamentoEcgPor').value,
      valorLimiteTotalEcgPagoPorTerceiro: this.cadastroTerceiroForm.get('valorLimiteTotal').value,
      dataReferencia: this.cadastroTerceiroForm.get('dataReferencia').value,
    } as TipoPagamentoEcgTerceiro;
    this.TipoPagamentoEcgTerceiroService.salvarTipoPagamentoEcgTerceiro(cadastro).subscribe(
      (res) => {
        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Cadastro realizado com sucesso.'
        });
        this.aposSalvar();
        this.loadingService.liberaTela();
        this.irParaPesquisa();
      },
      (error) => {
        this.ocorrencias = this.TipoPagamentoEcgTerceiroService.ocorrencias;
        this.loadingService.liberaTela();
        return error;
      }
    );
  }

  irParaPesquisa() {
    this.router.navigate(['ecg-por-terceiros', 'pesquisa']);
  }

  cancelar() {
    this.modoEdicaoR = false;
    this.modoCadastro = false;
    this.modoVisualizacao = true;
    this.atualizaStatusCamposEdicao();
  }

  editarLimite() {
    this.modoEdicaoR = true;
    this.modoCadastro = false;
    this.modoVisualizacao = false;
    this.atualizaStatusCamposEdicao();
  }

  atualizaStatusCamposEdicao() {
    if (this.modoCadastro) {
      this.cadastroTerceiroForm.get('pagamentoEcgPor').enable();
      this.cadastroTerceiroForm.get('valorLimiteTotal').enable();
      this.cadastroTerceiroForm.get('dataReferencia').enable();
    } else if (this.modoEdicaoR) {
      this.cadastroTerceiroForm.get('pagamentoEcgPor').disable();
      this.cadastroTerceiroForm.get('valorLimiteTotal').enable();
      this.cadastroTerceiroForm.get('dataReferencia').enable();
    } else {
      this.cadastroTerceiroForm.get('pagamentoEcgPor').disable();
      this.cadastroTerceiroForm.get('valorLimiteTotal').disable();
      this.cadastroTerceiroForm.get('dataReferencia').disable();
    }
  }

  modoStatus() {
    this.route.params.forEach(params => {
      if (params['id'] != undefined) {
        this.ideEcgTerceiro = +params['id'];
      }
      if (this.ideEcgTerceiro != null){
        this.modoVisualizacao = true;
        this.modoCadastro = false;
        this.modoEdicaoR = false;
      }else{
        this.modoCadastro = true;
        this.modoVisualizacao = false;
        this.modoEdicaoR = false;
      }
    }).then(r => {
      return r;
    });
  }

  async salvarEdicao() {
    this.antesDeSalvar();
    if (this.cadastroTerceiroForm.invalid) {
      this.cadastroTerceiroForm.markAllAsTouched();
      return;
    }
    this.loadingService.bloqueiaTela();
    const edicao = {
      ide: this.ideEcgTerceiro,
      nomeTipoPagamentoEcgTerceiro: this.cadastroTerceiroForm.get('pagamentoEcgPor').value,
      valorLimiteTotalEcgPagoPorTerceiro: this.cadastroTerceiroForm.get('valorLimiteTotal').value,
      dataReferencia: this.cadastroTerceiroForm.get('dataReferencia').value,
    } as TipoPagamentoEcgTerceiro;
    this.ocorrencias = [];
    this.TipoPagamentoEcgTerceiroService.salvarEdicaoTipoPagamentoEcgTerceiro(edicao).subscribe(() => {
        this.messageService.addMessage({
          title: 'Sucesso',
          type: 'CRUD_OPERATION',
          level: messageLevel.SUCCESS,
          message: 'Edição realizada com sucesso.'
        });
        this.aposSalvar();
        this.loadingService.liberaTela();
        this.irParaPesquisa();
      },
      (error) => {
        this.ocorrencias = this.TipoPagamentoEcgTerceiroService.ocorrencias;
        this.loadingService.liberaTela();
        return error;
      }
    );
  }
}
